import styled from "@emotion/styled";

import {Button, Segment, Radio as RadioBase} from "@britishcouncil/react-extro-ui";

export const Root = styled(Segment)`
    gap: 0;
    padding: 30px 30px;
    background: transparent;
    border: 1px solid #C8C8C8;

    .ex-segment {
        padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.md};
    }

    h4 {
        font-weight: 700;
        color: ${({theme}) => theme.colors.text.header};
        font-family: Arial, serif;
    }

    h5 {
        color: ${({theme}) => theme.colors.text.header};
        font-family: Arial, serif;
    }
`;

export const Deadline = styled.span`
    font-weight: 700;
`
export const PayMethodContainer = styled.div`
    margin-bottom: 20px;

    .payButton {
        display: block;
        width: auto;
        align-self: center;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .subtitle {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: 400;
        color: #54565A;
    }
`

export const ReturnButton = styled(Button)`
    display: flex;
    width: 200px;
    align-self: first;
`

export const Divider = styled.hr`
    border-top: 1px dashed #003B4A;
    margin: 2px;
`;

export const DescriptionContainer = styled(Segment)`
    font-size: 14px;
    color: #000;
    font-family: Arial, serif;

    p {
        margin: 0 0 10px;
    }
`

export const Radio = styled(RadioBase)`
    input {
        display: none;
    }
`;